// W2Cook Billing Dashboard — Configuration error screen
// Shown when Firebase env vars are missing, instead of a blank white page.

import { tokens as T } from "../theme/tokens";

interface Props {
  missingKeys: string[];
}

export function ConfigErrorScreen({ missingKeys }: Props) {
  return (
    <div style={{
      minHeight: "100vh", background: T.bg, color: T.text,
      display: "flex", alignItems: "center", justifyContent: "center",
      fontFamily: "'DM Sans', system-ui, sans-serif", padding: 20,
    }}>
      <div style={{ width: "100%", maxWidth: 520 }}>
        <div style={{
          background: T.surface, border: `1px solid ${T.ember}40`,
          borderRadius: 14, padding: 28,
        }}>
          <div style={{ fontSize: 17, fontWeight: 600, color: T.ember, marginBottom: 10 }}>
            Configuration incomplete
          </div>
          <div style={{ fontSize: 13, color: T.textMuted, marginBottom: 20, lineHeight: 1.6 }}>
            The dashboard built successfully but authentication is not configured,
            so sign-in is unavailable.
          </div>

          <div style={{ fontSize: 11, color: T.textMuted, letterSpacing: "0.08em", marginBottom: 8 }}>
            MISSING VALUES
          </div>
          <div style={{
            background: T.bg, border: `1px solid ${T.border}`, borderRadius: 8,
            padding: "12px 14px", marginBottom: 20,
          }}>
            {missingKeys.map(k => (
              <div key={k} style={{ fontSize: 12, color: T.gold, fontFamily: "monospace", marginBottom: 4 }}>
                {k}
              </div>
            ))}
          </div>

          <div style={{ fontSize: 13, color: T.textMuted, lineHeight: 1.7 }}>
            These are read at <strong style={{ color: T.text }}>build time</strong>, so they must be set as
            <strong style={{ color: T.text }}> GitHub repository secrets</strong> — the GitHub Actions
            workflow produces the bundle. Values set only in the Cloudflare Pages
            dashboard will not apply.
            <br /><br />
            Add them under <span style={{ color: T.text }}>Settings → Secrets and variables → Actions</span>,
            then re-run the deploy.
          </div>
        </div>
      </div>
    </div>
  );
}
